// src/lib/api/menuApi.js
import Http from "../../../core/Http";

/**
 * DB에서 메뉴 데이터 조회 API
 * GET /api/cms/menu
 * @param {Object} options - 옵션 객체
 * @param {string} options.rootMenuCd - 루트 메뉴 코드 (예: 'BASIC', 'ALLIANCE')
 */
export const fetchMenuFromDb = async (options = {}) => {
    try {
        const params = {};
        if (options.rootMenuCd) {
            params.rootMenuCd = options.rootMenuCd;
        }
        // Http 인터셉터가 이미 response.data를 반환하므로 바로 할당
        const data = await Http.get("/api/cms/menu", { params });
        return data;
    } catch (err) {
        console.error("Error fetching menu from DB:", err);
        throw err;
    }
};

const MENU_API_URL = '/api/system/menu';

/**
 * 메뉴 트리 목록을 조회합니다.
 * @param {object} params - 조회 조건 (MenuTreeSearch)
 * @returns {Promise<any>}
 */
export const getMenuTree = (params) => {
    return Http.get(`${MENU_API_URL}/tree`, { params });
};

/**
 * 새로운 메뉴를 저장합니다.
 * @param {object} menuData - 저장할 메뉴 데이터 (MenuSave)
 * @returns {Promise<any>}
 */
export const saveMenu = (menuData) => {
    return Http.post(MENU_API_URL, menuData);
};

/**
 * 기존 메뉴를 수정합니다.
 * @param {number} menuNo - 수정할 메뉴의 번호
 * @param {object} menuData - 수정할 메뉴 데이터 (MenuChange)
 * @returns {Promise<any>}
 */
export const changeMenu = (menuNo, menuData) => {
    return Http.put(`${MENU_API_URL}/${menuNo}`, menuData);
};

/**
 * 메뉴를 삭제합니다.
 * @param {number} menuNo - 삭제할 메뉴의 번호
 * @returns {Promise<any>}
 */
export const deleteMenu = (menuNo) => {
    return Http.delete(`${MENU_API_URL}/${menuNo}`);
};

/**
 * 메뉴와 연결된 CMS 페이지 콘텐츠를 조회합니다.
 * @param {number} menuNo - 메뉴 번호
 * @returns {Promise<any>}
 */
export const getMenuPageContent = (menuNo) => {
    return Http.get(`${MENU_API_URL}/page/${menuNo}`);
};

/**
 * 메뉴와 연결된 CMS 페이지 콘텐츠를 생성합니다.
 * @param {object} payload - { menuNo, roleCode, pageDataJson }
 * @returns {Promise<any>}
 */
export const createMenuPageContent = (payload) => {
    return Http.post(`${MENU_API_URL}/page`, payload);
};

/**
 * 메뉴와 연결된 CMS 페이지 콘텐츠를 업데이트합니다.
 * @param {number} pageUid - CMS 페이지의 UID
 * @param {string} jsonData - 업데이트할 JSON 데이터 (문자열 형태)
 * @returns {Promise<any>}
 */
export const updateMenuPageContent = (pageUid, jsonData) => {
    return Http.put(`${MENU_API_URL}/page/${pageUid}`, jsonData, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
